module.exports = __webpack_public_path__ + "img/lt-icone-logo-laboratoire-tournier.2eb8ee9e.svg";